export const commonStyleObj = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    color: 'black',
    padding: '10px'
}